export default "__VITE_ASSET__B_85u9OP__"